import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import {
  Instagram,
  Facebook,
  Youtube,
  Twitter,
  Music2,
  Music,
  Mail,
  MessageCircle,
} from "lucide-react";

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  x: Twitter,
  youtube: Youtube,
  "youtube-epics": Youtube,
  "youtube-music": Music2,
  spotify: Music,
  "apple-music": Music,
  substack: Mail,
  // WhatsApp channels — master + per-faith
  "whatsapp-master": MessageCircle,
  "whatsapp-hindu": MessageCircle,
  "whatsapp-buddhist": MessageCircle,
  "whatsapp-zen": MessageCircle,
  "whatsapp-christian": MessageCircle,
  "whatsapp-sufi": MessageCircle,
};

export default function ChannelCard({ channel, index = 0 }) {
  const Icon = ICONS[channel.id] || Music;
  return (
    <motion.a
      href={channel.url}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{
        duration: 0.8,
        delay: Math.min(index * 0.04, 0.25),
        ease: [0.22, 1, 0.36, 1],
      }}
      className="group block card-shrine rounded-sm p-6 md:p-7"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3.5">
          <div className="w-11 h-11 rounded-full border border-dharma-gold/35 flex items-center justify-center text-dharma-gold-deep group-hover:border-dharma-gold group-hover:bg-dharma-gold/10 transition-colors duration-700 ease-breath">
            <Icon size={18} />
          </div>
          <div>
            <div className="font-display text-base md:text-lg text-ink">
              {channel.label}
            </div>
            <div className="font-body text-xs text-ink-mute mt-0.5">
              {channel.handle}
            </div>
          </div>
        </div>
        <ArrowUpRight
          size={18}
          className="text-ink-mute group-hover:text-dharma-gold-deep transition-colors duration-700 ease-breath"
        />
      </div>
      {channel.note && (
        <p className="font-serif text-base text-ink-soft leading-snug mt-4">
          {channel.note}
        </p>
      )}
    </motion.a>
  );
}
